import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { Modal, message } from "antd";
import { resetMfa, getUserList } from "../redux/slices/UserSlice";
import { BTN_TXT } from "../constants/constants";

/**
 * Super Admin action: clear a user's MFA so they must scan a new QR on next login.
 */
export const useResetMfa = () => {
  const dispatch = useDispatch();

  return useCallback(
    (targetUserId, userName) =>
      new Promise((resolve) => {
        Modal.confirm({
          title: "Reset MFA?",
          content: (
            <>
              This clears the authenticator for{" "}
              <strong>{userName || targetUserId}</strong>. Their current sessions
              will end, and they must log in again and scan a new QR code before
              accessing the dashboard.
            </>
          ),
          okText: BTN_TXT.RESET_MFA,
          okButtonProps: { danger: true },
          cancelText: BTN_TXT.CANCEL,
          onCancel: () => resolve(false),
          onOk: async () => {
            const res = await dispatch(
              resetMfa({
                targetUserId,
                reason: "Manual identity verification by Super Admin",
              })
            );

            if (res.meta.requestStatus !== "fulfilled") {
              Modal.error({
                title: "Reset MFA failed",
                content:
                  res.payload?.error ||
                  res.payload?.message ||
                  res.payload ||
                  "Failed to reset MFA",
              });
              return resolve(false);
            }

            message.success(
              res.payload?.message ||
                "MFA reset successfully. User must set up a new authenticator on next login."
            );
            dispatch(getUserList());
            resolve(true);
          },
        });
      }),
    [dispatch]
  );
};
